import dayjs from 'dayjs';
import { formatDate } from '../../../utils/date';

/* ─── Helpers ────────────────────────────────────────────────────────── */

const titleCase = (s?: string) =>
  (s ?? '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

const fmtTime = (t?: string) => (t ? dayjs(t).format('hh:mm A') : '-');

const fmtDur = (secs: number) => {
  const m = Math.round((secs || 0) / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`;
};

/* ─── Columns for the addon-sessions table ───────────────────────────── */

export const sessionColumns = [
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
    render: (v: string) => v ?? '-',
  },
  {
    title: 'Client',
    dataIndex: 'name',
    key: 'client',
    render: (_: unknown, r: any) => (
      <div className="ic-sc-cell">
        <div className="ic-sc-name">{r.name || '-'}</div>
        {r.phoneNumber && <div className="ic-sc-phone">{r.phoneNumber}</div>}
      </div>
    ),
  },
  {
    title: 'Service',
    key: 'service',
    render: (_: unknown, r: any) =>
      `${titleCase(r.serviceType) || '-'}${r.subCategory ? ` · ${titleCase(r.subCategory)}` : ''}`,
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    render: (v: string) => (v ? titleCase(v) : '-'),
  },
  {
    title: 'Plan',
    dataIndex: 'planName',
    key: 'planName',
    render: (v: string) => v ?? '-',
  },
  {
    title: 'Trainer Name',
    dataIndex: 'trainerName',
    key: 'trainerName',
    render: (v: string) => v ?? '-',
  },
  {
    title: 'Session Date',
    dataIndex: 'sessionDate',
    key: 'sessionDate',
    render: (v: string, r: any) => {
      if (!v) return '-';
      const start = fmtTime(v);
      const end = r.endedAt ? fmtTime(r.endedAt) : null;
      return (
        <div>
          <div>{formatDate(v)}</div>
          <div style={{ fontSize: 12, color: 'var(--placeholder)' }}>
            {start}{end ? <span style={{ color: 'var(--muted)' }}> ({end})</span> : null}
          </div>
        </div>
      );
    },
  },
  {
    title: 'Duration',
    key: 'duration',
    align: 'center' as const,
    render: (_: unknown, r: any) =>
      r.activeDurationMinutes != null ? `${r.activeDurationMinutes}m`
        : r.activeSeconds != null ? fmtDur(r.activeSeconds) : '-',
  },
  {
    title: 'Per Session Amount',
    key: 'perSessionValue',
    align: 'right' as const,
    render: (_: unknown, r: any) => {
      const v = r.perSessionAmount ?? r.sessionValue ?? r.value ?? r.amount;
      return v != null ? `₹${Number(v).toLocaleString('en-IN')}` : '-';
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center' as const,
    render: (v: string) => (v ? <span className={`ic-sess-status ${v}`}>{v}</span> : '-'),
  },
];
